import { Directive, HostBinding } from '@angular/core';

/**
 * Liga a validação padronizada de campos obrigatórios em um formulário: dentro
 * dele, todo campo obrigatório vazio passa a ser destacado em vermelho e a
 * exibir a mensagem do motivo, de qualquer tipo de campo.
 *
 * É o único interruptor do recurso. Aplica a classe `.form-validacao`, que
 * responde pelo destaque visual no styles.scss, e serve de escopo para a
 * FieldErrorDirective, que responde pela mensagem. Os campos alcançam esta
 * diretiva por injeção de dependência, subindo a árvore de injetores —
 * inclusive a partir de componentes filhos, como o app-endereco-form. Por isso
 * não é preciso repetir nada campo a campo nem inspecionar o DOM.
 */
@Directive({
    selector: '[ValidacaoObrigatorios]',
})
export class ValidacaoObrigatoriosDirective {

    @HostBinding('class.form-validacao') readonly aplicaDestaqueVisual = true;
}
